import axios from 'axios';
import { useParams, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { urlSearch } from '@/search';

import getVideosAdminViewsQuery from '../helpers/getVideosAdminViewsQuery';
import getAxiosConfig from '../helpers/getAxiosConfig';
import handleVideoUnauthorizedError from '../helpers/handleVideoUnauthorizedError';

export default () => {
  const { id, type, orgId } = useParams();
  const location = useLocation();
  const { page, per_page: perPage } = getVideosAdminViewsQuery({ props: { location } });
  const versionId = urlSearch.getValue('version_id');
  const queryKey = useMemo(() => ['videoViews', id, versionId, page], [id, page, versionId]);

  const videoViews = useQuery({
    queryKey,
    keepPreviousData: true,
    queryFn: async () => {
      try {
        const { data } = await axios(
          getAxiosConfig('get-videos-admin-views', { id, page, perPage, versionId }),
        );
        return data;
      } catch (error) {
        handleVideoUnauthorizedError({
          error,
          orgId,
          type,
          conditionedQueryCache: videoViews,
        });
        return {};
      }
    },
  });

  return videoViews;
};
